import {
  Component, Vue,
} from 'vue-property-decorator';
import WithRender from './lawyer-persona.html';
import BasePersona from '../base-persona/base-persona';
import SharedDataService from '@/modules/shared/services/shared-data-service';
import { Inject } from 'vue-di-container';

@WithRender
@Component({
  components: {
    BasePersona,
  },
})
export default class LawyerPersona extends Vue {
  @Inject(SharedDataService) sharedDataService!:SharedDataService;

  public get target() {
    return [this.sharedDataService.Personas.LAWYER];
  }
}
